import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../../../components/calendar/Calendar.js';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';

function SubAdminReferenceUnitRate(props) {
    const formRef = useRef(null)

    const [reportdate_filter, setReportdate_filter] = useState(dayjs(new Date()));
    const [datalist, setDatalist] = useState([]);
    const [dataitem, setDataitem] = useState({
        datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
        mea_422_onpeak: 0,
        mea_422_offpeak: 0,
        pea_312_onpeak: 0,
        pea_312_offpeak: 0,
        pea_322_onpeak: 0,
        pea_322_offpeak: 0,
        pea_421_onpeak: 0,
        pea_421_offpeak: 0,
        pea_422_onpeak: 0,
        pea_422_offpeak: 0,
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const onCalendarChange_Filter = (date, dateString) => {
        setReportdate_filter(date)
    };

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function init_item() {
        setDataitem({
            datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
            mea_422_onpeak: 0,
            mea_422_offpeak: 0,
            pea_312_onpeak: 0,
            pea_312_offpeak: 0,
            pea_322_onpeak: 0,
            pea_322_offpeak: 0,
            pea_421_onpeak: 0,
            pea_421_offpeak: 0,
            pea_422_onpeak: 0,
            pea_422_offpeak: 0,
        })
    }

    useEffect(() => {
        api_load()
    }, [reportdate_filter]);

    useEffect(() => {
        return () => {
            setDatalist([])
            setDataitem({})
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading unit rate list." })
        await sleep(500)

        const formData = new FormData()
        formData.append('year', dayjs(reportdate_filter).format('YYYY'))
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refunitrate/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.unitrate !== null && response.data.unitrate !== undefined) {
                    setDatalist(response.data.unitrate)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_edit() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing unit rate in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('datetimestamp', dataitem.datetimestamp)
            formData.append('mea_422_onpeak', dataitem.mea_422_onpeak)
            formData.append('mea_422_offpeak', dataitem.mea_422_offpeak)
            formData.append('pea_312_onpeak', dataitem.pea_312_onpeak)
            formData.append('pea_312_offpeak', dataitem.pea_312_offpeak)
            formData.append('pea_322_onpeak', dataitem.pea_322_onpeak)
            formData.append('pea_322_offpeak', dataitem.pea_322_offpeak)
            formData.append('pea_421_onpeak', dataitem.pea_421_onpeak)
            formData.append('pea_421_offpeak', dataitem.pea_421_offpeak)
            formData.append('pea_422_onpeak', dataitem.pea_422_onpeak)
            formData.append('pea_422_offpeak', dataitem.pea_422_offpeak)
            formData.append('year', dayjs(reportdate_filter).format('YYYY'))
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refunitrate/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your unit rate has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.unitrate !== null && response.data.unitrate !== undefined) {
                        setDatalist(response.data.unitrate)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> Unit Rate</h4>
                                    <p className="mb-0">Manage all parameter of unit rate</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className='d-flex'>
                            <div className="d-block ">
                                <label htmlFor="reporttype" className="form-label mb-0">Select Year Filter</label>
                                <Calendar
                                    allowClear={false}
                                    className={"form-control"}
                                    onChange={onCalendarChange_Filter}
                                    picker={'year'}
                                    style={{
                                        fontFamily: "poppins",
                                        fontSize: "0.75rem",
                                        Color: "black",
                                        lineHeight: "1.5",
                                        cursor: "pointer",
                                    }}
                                    value={reportdate_filter}
                                />
                            </div>
                        </div>

                        <h5 className='mt-3'>Unit Rate Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th style={{ width: "110px" }} rowSpan={2}>Month</th>
                                        <th colSpan={2} className='text-center'>MEA 4.2.2 (12-24 kV)</th>
                                        <th colSpan={2} className='text-center'>PEA 3.1.2 (22-33 kV)</th>
                                        <th colSpan={2} className='text-center'>PEA 3.2.2 (22-33 kV)</th>
                                        <th colSpan={2} className='text-center'>PEA 4.2.1 (69 kV ขึ้นไป)</th>
                                        <th colSpan={2} className='text-center'>PEA 4.2.2 (22-33 kV)</th>
                                        <th rowSpan={2}>Edit Time</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role === "Admin" ?
                                                    <th className="text-center" style={{ width: "100px" }} rowSpan={2}>Action</th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                    <tr className="admintable-header">
                                        <th className='text-center'>On-peak</th>
                                        <th className='text-center'>Off-peak</th>
                                        <th className='text-center'>On-peak</th>
                                        <th className='text-center'>Off-peak</th>
                                        <th className='text-center'>On-peak</th>
                                        <th className='text-center'>Off-peak</th>
                                        <th className='text-center'>On-peak</th>
                                        <th className='text-center'>Off-peak</th>
                                        <th className='text-center'>On-peak</th>
                                        <th className='text-center' >Off-peak</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.datetimestamp}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {dayjs(new Date(data.datetimestamp)).format('YYYY-MMM')}</td>
                                                <td className='text-center'>{data.mea_422_onpeak > 0 ? data.mea_422_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.mea_422_offpeak > 0 ? data.mea_422_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_312_onpeak > 0 ? data.pea_312_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_312_offpeak > 0 ? data.pea_312_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_322_onpeak > 0 ? data.pea_322_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_322_offpeak > 0 ? data.pea_322_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_421_onpeak > 0 ? data.pea_421_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_421_offpeak > 0 ? data.pea_421_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_422_onpeak > 0 ? data.pea_422_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.pea_422_offpeak > 0 ? data.pea_422_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td>{data.edittime !== "-" ? data.edittime : "-"}</td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role === "Admin" && data.mea_422_onpeak > 0 ?
                                                            <td>
                                                                <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered " title="Edit"
                                                                    onClick={() => {
                                                                        setDataitem(data)
                                                                        setModal_item(true)
                                                                    }}><i className="fas fa-pen"></i></Link>
                                                            </td>
                                                            :
                                                            <td><div style={{ height: "25px" }}>-</div></td>
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-md modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> Edit Unit Rate</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="month">Month (YYYY-MM)</label>
                                                                <input type="text" className="form-control" name="month" value={dayjs(new Date(dataitem.datetimestamp)).format('YYYY-MM')} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6 className='font-sarabun'>MEA 4.2.2 (12-24 kV)</h6>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="mea_422_onpeak">On-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="mea_422_onpeak" min={1} max={20} step={0.0001} value={dataitem.mea_422_onpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        mea_422_onpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="mea_422_offpeak">Off-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="mea_422_offpeak" min={1} max={20} step={0.0001} value={dataitem.mea_422_offpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        mea_422_offpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6 className='font-sarabun'>PEA 3.1.2 (22-33 kV)</h6>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_312_onpeak">On-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_312_onpeak" min={1} max={20} step={0.0001} value={dataitem.pea_312_onpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_312_onpeak: e.target.value,
                                                                        pea_312_offpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_312_offpeak">Off-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_312_offpeak" min={1} max={20} step={0.0001} value={dataitem.pea_312_offpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_312_offpeak: e.target.value,
                                                                        pea_312_onpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6 className='font-sarabun'>PEA 3.2.2 (22-33 kV)</h6>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_322_onpeak">On-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_322_onpeak" min={1} max={20} step={0.0001} value={dataitem.pea_322_onpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_322_onpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_322_offpeak">Off-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_322_offpeak" min={1} max={20} step={0.0001} value={dataitem.pea_322_offpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_322_offpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6 className='font-sarabun'>PEA 4.2.1 (69 kV ขึ้นไป)</h6>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_421_onpeak">On-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_421_onpeak" min={1} max={20} step={0.0001} value={dataitem.pea_421_onpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_421_onpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_421_offpeak">Off-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_421_offpeak" min={1} max={20} step={0.0001} value={dataitem.pea_421_offpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_421_offpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6 className='font-sarabun'>PEA 4.2.2 (22-33 kV)</h6>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_422_onpeak">On-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_422_onpeak" min={1} max={20} step={0.0001} value={dataitem.pea_422_onpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_422_onpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="pea_422_offpeak">Off-Peak (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="pea_422_offpeak" min={1} max={20} step={0.0001} value={dataitem.pea_422_offpeak} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        pea_422_offpeak: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_edit() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceUnitRate